import React from "react";
import { Box, Paper, Typography, Stack } from "@mui/material";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";

function MaintenancePage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(135deg, #f5f7fa 0%, #e4ecf7 50%, #f0f4ff 100%)",
        px: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 480,
          width: "100%",
          px: { xs: 4, sm: 6 },
          py: { xs: 5, sm: 7 },
          textAlign: "center",
          borderRadius: 4,
          border: "1px solid",
          borderColor: "divider",
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          backdropFilter: "blur(8px)",
        }}
      >
        <Stack spacing={2.5} alignItems="center">
          <BuildCircleIcon sx={{ fontSize: 64, color: "primary.main" }} />
          <Typography variant="h5" fontWeight={700} color="text.primary">
            温馨提示
          </Typography>
          <Typography variant="body1" color="text.secondary">
            当前系统升级维护中...
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}

export default MaintenancePage;
